import React from "react";
import { motion } from "framer-motion";
import {
  Ear,
  Search,
  BookOpen,
  Lightbulb,
  CheckCircle2,
  LineChart,
} from "lucide-react";
import { SITE } from "@/data/site";

const ICONS = {
  ear: Ear,
  search: Search,
  "book-open": BookOpen,
  lightbulb: Lightbulb,
  "check-circle": CheckCircle2,
  "line-chart": LineChart,
};

export default function Approach() {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="relative bg-[#0E0E11] py-24 lg:py-32 overflow-hidden border-y border-white/[0.04]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-[#F5A623] font-semibold">
            <span className="divider-gold" /> The Sunrise Approach
          </span>
          <h2
            data-testid="approach-headline"
            className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight silver-text"
          >
            We are 100% believers in <em className="text-[#F5A623]">education</em> — not transactions.
          </h2>
          <p className="mt-5 text-[#B7BBC4] text-base lg:text-lg leading-relaxed">
            Six deliberate steps designed to give you complete clarity before any decision is made — and an annual rhythm that keeps your plan honest.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {SITE.approach.map((s, i) => {
            const Icon = ICONS[s.icon] || Lightbulb;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.55, delay: i * 0.06 }}
                className="group relative glass-card rounded-md p-7 hover:-translate-y-1 transition-all duration-300"
                data-testid={`approach-step-${i + 1}`}
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-full bg-white/[0.04] border border-[#F5A623]/30 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#F5A623]" strokeWidth={1.6} />
                  </div>
                  <span className="font-serif text-3xl text-white/10 group-hover:text-[#F5A623]/40 transition-colors">
                    {s.step}
                  </span>
                </div>
                <h3 className="mt-6 font-serif text-2xl text-white">{s.title}</h3>
                <p className="mt-3 text-sm text-[#9CA0AA] leading-relaxed">{s.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
